var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHtlPersonalTrainerFilled = function SvgHtlPersonalTrainerFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M2.842 12.669a1.391 1.391 0 0 1-.84-1.363c.182-2.926.927-5.79 2.193-8.434a1.448 1.448 0 0 1 1.307-.8c.099 0 .197.01.294.03l1.785.356a.5.5 0 0 1 .378.642c-.517 1.634-.52 1.636-.684 1.754a.5.5 0 0 1-.455.068 1.1 1.1 0 0 0-.346-.068c-.409 0-.481.519-.491.616v3.978h.485a.572.572 0 0 0 .439-.226 5.2 5.2 0 0 1 4.024-2.2c.645-.01 1.28.166 1.825.51a2.963 2.963 0 0 1 1.224 2.264 3.64 3.64 0 0 1-1.69 3.048l-.017.013a6.466 6.466 0 0 1-3.834 1.078 14.973 14.973 0 0 1-5.597-1.266Z"
  })));
};
export default SvgHtlPersonalTrainerFilled;